import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    configId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpiAudit.setAuditFlow, {
        id,
        configId,
    }, options);
    if (error) return { error, status };
    return content || { };
};
